// extracted by mini-css-extract-plugin
module.exports = {"greyFontColor":"YTHelperCommonModalStyle_greyFontColor__jF8Ja","containerForVideoDescription":"YTHelperCommonModalStyle_containerForVideoDescription__2K9K-"};